var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoUrl)?_c('div',{staticClass:"video-responsive"},[_c('div',{ref:"artplayerContainer",staticClass:"artplayer-app"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }